import { BreadcrumbRouteConfig } from './types';
import { workflowsRoutes } from './routes/workflows.routes';
import { templatesRoutes } from './routes/templates.routes';
import { promptsRoutes } from './routes/prompts.routes';
import { toolsRoutes } from './routes/tools.routes';
import { skillsRoutes } from './routes/skills.routes';
import { secretsRoutes } from './routes/secrets.routes';
import { connectionsRoutes } from './routes/connections.routes';
import { filesRoutes } from './routes/files.routes';
import { configsRoutes } from './routes/configs.routes';
import { metricsRoutes } from './routes/metrics.routes';
import { appsRoutes } from './routes/apps.routes';
import { adminRoutes } from './routes/admin.routes';
import { teamRoutes } from './routes/team.routes';

/**
 * Nested breadcrumb route configuration
 * Uses React Router's route matching - parent breadcrumbs are inherited by children
 *
 * Routes are organized by feature in separate files:
 * - workflows.routes.ts - Workflow breadcrumbs
 * - templates.routes.ts - Template breadcrumbs
 * - prompts.routes.ts - Prompt breadcrumbs
 * - tools.routes.ts - Tools breadcrumbs
 * - secrets.routes.ts - Secrets breadcrumbs
 * - connections.routes.ts - Connections breadcrumbs
 * - admin.routes.ts - Admin breadcrumbs
 */
export const breadcrumbRoutes: BreadcrumbRouteConfig[] = [
    workflowsRoutes,
    templatesRoutes,
    promptsRoutes,
    toolsRoutes,
    skillsRoutes,
    secretsRoutes,
    configsRoutes,
    metricsRoutes,
    connectionsRoutes,
    filesRoutes,
    appsRoutes,
    teamRoutes,
    adminRoutes,
];
